/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerFindAnyByIdQueryResponse,
  TelegramGeoControllerFindAnyByIdPathParams,
} from '../types/TelegramGeoControllerFindAnyById.ts';

function getTelegramGeoFindAnyByIdUrl(id: TelegramGeoControllerFindAnyByIdPathParams['id']) {
  const res = { method: 'GET', url: `/api/telegram/geo/${id}` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/:id}
 */
export async function telegramGeoFindAnyById(
  id: TelegramGeoControllerFindAnyByIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerFindAnyByIdQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoFindAnyByIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
